module.exports = __webpack_public_path__ + "static/img/logo02.034ec80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo02.png
// module id = dBs+
// module chunks = 1